import { useState, useEffect } from "react";

function useFetchJSONData(apiName) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchJSONData = async () => {
      try {
        const apiEndPoint = window.THREE_REACT_APP_GLOBAL.api_endpoint;
        const lang = window.THREE_REACT_APP_GLOBAL.language;
        const url = `${apiEndPoint}${lang}/${apiName}.json`;

        const response = await fetch(url);
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const jsonResponse = await response.json();
        setData(jsonResponse);
      } catch (err) {
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    fetchJSONData();
  }, [apiName]);

  return { data, loading, error };
}

export default useFetchJSONData;
